class AppStorage {
    storeToken(token){
        localStorage.setItem('token',token)
    }

    storeUserName(user_name) {
        localStorage.setItem('user_name', user_name)
    }

    storeUserId(user_id) {
        localStorage.setItem('user_id', user_id)
    }

    storeMember(member) {
        localStorage.setItem('member', member)
    }

    storeRole(role_id) {
        localStorage.setItem('role_id', role_id)
    }

    store(user_name,user_id, token, member, role_id) {
        this.storeToken(token)
        this.storeUserName(user_name)
        this.storeUserId(user_id)
        this.storeMember(member)
        this.storeRole(role_id)
    }

    clear(){
        localStorage.removeItem('token')
        localStorage.removeItem('user_name')
        localStorage.removeItem('user_id')
        localStorage.removeItem('member')
        localStorage.removeItem('role_id')
        localStorage.removeItem('profile')
    }

    getToken(){
        return localStorage.getItem('token') ? localStorage.getItem('token') : false
    }

    getUserName(){
        return localStorage.getItem('user_name')
    }

    getUserId(){
        return localStorage.getItem('user_id')
    }

    storeProfile(profile) {
        localStorage.setItem('profile',JSON.stringify(profile))
    }

    getProfile() {
        return JSON.parse(localStorage.getItem("profile") || "[]");
    }

    getMember() {
        return localStorage.getItem('member')
    }

    getRole() {
        return localStorage.getItem('role_id')
    }

    storeVideos(videos) {
        localStorage.setItem('videos',JSON.stringify(videos))
    }

    getVideos() {
        return JSON.parse(localStorage.getItem("videos") || "[]");
    }

    storeCategories(categories) {
      localStorage.setItem('categories',JSON.stringify(categories))
    }

    getCategories() {
        return JSON.parse(localStorage.getItem("categories") || "[]");
    }

}

export default AppStorage = new AppStorage()
